export default __webpack_public_path__ + "static/media/023.85185a6b.jpg";